import { render, staticRenderFns } from "./Portables.vue?vue&type=template&id=0253f4d8&scoped=true&"
import script from "./Portables.vue?vue&type=script&lang=jsx&"
export * from "./Portables.vue?vue&type=script&lang=jsx&"
import style0 from "./Portables.vue?vue&type=style&index=0&id=0253f4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253f4d8",
  null
  
)

export default component.exports